import { render, staticRenderFns } from "./configurator.vue?vue&type=template&id=75569c8e&scoped=true&"
import script from "./configurator.vue?vue&type=script&lang=js&"
export * from "./configurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75569c8e",
  null
  
)

export default component.exports